<template>
	<div class="home-page hone_page_margin">
		<div class="wei_main_info">
			<a-card style="width:100%" :tabList="tabListNoTitle" :activeTabKey="noTitleKey">
				<div class="wei_main_info_main">
					<div class="essential_information">
						<h2>基本信息</h2>
						<div class="items">
							<img alt="头像" :src="avatar"/>
						</div>
						<div class="items">
							<span>用户名：</span>
							<span>{{users.username}}</span>
						</div>
						<div class="items">
							<span>姓名：</span>
							<span>{{users.nickName}}</span>
						</div>
						<div class="items">
							<span>角色：</span>
							<span>{{users.roleName}}</span>
						</div>
						<div class="items">
							<span>组织：</span>
							<span>{{users.deptName}}</span>
						</div>
					</div>
					<div class="essential_information safe">
						<h2>安全</h2>
						<div class="items">
							<span>账户密码：</span>
							<span class="items-text">已设置</span>
							<p class="items-tip-text">请设置一个包含大写字母、小写字母和数字，不包含用户名，并且长度在8-18位的密码</p>
							<div class="fr">
								<a-button type="primary" @click="showModal_pw">修改</a-button>
							</div>
						</div>
						<div class="items">
							<span>手机号码：</span>
							<span class="items-text" v-if="users.mobile"><span
									style="margin-right:10px;">已绑定</span>{{users.mobile}}</span>
							<span class="items-text" v-else>未设置</span>
							<p class="items-tip-text">绑定手机后可以享受手机验证码登录和手机找回密码的服务</p>
							<div class="fr">
								<a-button v-if="users.roleId!=1" type="primary" @click="showModal">修改</a-button>
							</div>
						</div>
						<div class="items">
							<span>邮箱：</span>
							<span v-if="users.email"><span
									style="margin-right:10px;">已绑定:</span>{{users.email}}</span>
							<span v-else>未设置</span>
							<div class="fr">
								<a-button v-if="users.roleId!=1" type="primary" @click="showModal_em">修改</a-button>
							</div>
						</div>
					</div>
					<div class="essential_information notice">
						<h2>消息提醒设置</h2>
						<div class="items">
							<span>系统通知：</span>
							<span>{{users.smsSystem?'系统消息将以短信的形式通知':'系统消息将以短信的形式通知'}}</span>
							<div class="fr">
								<div>
									<a-switch :disabled="users.roleId==1?true:false" v-model="users.smsSystem"
									          @change="onChangeSystem"/>
								</div>
							</div>
						</div>
						<div class="items">
							<span>业务通知：</span>
							<span>{{users.smsTodo?'业务事项将以短信的形式通知':'业务事项将以短信的形式通知'}}</span>
							<div class="fr">
								<a-switch :disabled="users.roleId==1?true:false" v-model="users.smsTodo"
								          @change="onChangeTodo"/>
							</div>
						</div>
						<div class="items">
							<span>邮件通知：</span>
							<span>{{users.smsTodo?'消息通知将以邮件的形式通知':'消息通知将以邮件的形式通知'}}</span>
							<div class="fr">
								<a-switch :disabled="users.roleId==1?true:false" v-model="users.emailSendMark"
								          @change="onChangeEmail"/>
							</div>
						</div>
					</div>
				</div>
			</a-card>
		</div>

		<!-- 密码修改 -->
		<div v-if="visible_pw">
			<a-modal title="修改密码" v-model="visible_pw" @ok="hideModal_pw" okText="确认" cancelText="取消">
				<a-form :form="form" @submit="handleSubmit_pw" class="common_alert">
					<div>
						<a-form-item>
							<a-input
									type="password"
									v-decorator="['password',{rules: [{ required: true, message: '请输入旧密码!' }]}]"
									placeholder="请输入旧密码"
							/>
						</a-form-item>
					</div>

					<div>
						<a-form-item>
							<a-input
									type="password"
									v-decorator="['newPassword',{rules: [{ required: true, message: '请输入新密码!' },{ validator: this.handlePasswordChecks }]}]"
									placeholder="请输入新密码（8-18大小写字母和数字组合）"
							/>
						</a-form-item>
					</div>
					<div>
						<a-form-item>
							<a-input
									type="password"
									v-decorator="['note',{rules: [{ required: true, message: '请输入确认密码!' },{ validator: this.handlePasswordCheck }]}]"
									placeholder="确认密码"
							/>
						</a-form-item>
					</div>
				</a-form>
			</a-modal>
		</div>
		<!-- 手机号修改弹框 -->
		<div v-if="visible">
			<a-modal :title="users.mobile?'修改绑定手机':'绑定手机'" v-model="visible" @ok="hideModal" okText="确认"
			         cancelText="取消">
				<a-form :form="form" @submit="handleSubmit" class="common_alert">
					<template v-if="users.mobile">
						<p>为了保护你的账号安全，变更前需要验证身份， 您的当前手机是{{users.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}</p>
						<div>
							<a-form-item>
								<a-input
										v-decorator="['oldMobile',{rules: [{ validator: this.checkUser }]}]"
										placeholder="请输入完整的当前手机号码"
								/>
							</a-form-item>
						</div>
						<h4>请输入您要绑定的新手机号码</h4>
						<div>
							<a-form-item>
								<a-input
										v-decorator="['newMobile',{rules: [{ validator: this.handlePhoneCheck }]}]"
										placeholder="请输入新的手机号码"
								/>
							</a-form-item>
						</div>
					</template>
					<template v-else>
						<h4>请输入您要绑定的手机号码</h4>
						<div>
							<a-form-item>
								<a-input
										v-decorator="['phoneNumber',{rules: [{ validator: this.handlePhoneNumberCheck }]}]"
										placeholder="请输入要绑定的手机号码"
								/>
							</a-form-item>
						</div>
					</template>
					<div>
						<a-form-item>
							<a-input
									style="width:52%;vertical-align: top;"
									v-decorator="['smsCode',{rules: [{ required: true, message: '请输入验证码!' }]}]"
									placeholder="请输入6位验证码"
							/>
							<a-button
									class="ant-btn-code fr"
									style="width:102px;"
									@click="SmsMsgSend"
									:disabled="SmsSendDisbled"
							>{{smsCodeText}}{{smsCodeText=='获取验证码'?'':'S'}}
							</a-button>
							<!--   <a-input
							class="fr"
							style="width:40%;"
							type="button"
							value="获取验证码"
							placeholder="请输入完整的当前手机号码"
							/>-->
						</a-form-item>
					</div>
				</a-form>
			</a-modal>
		</div>

		<!-- 邮箱修改弹框 -->
		<div v-if="visible_em">
			<a-modal title="修改绑定邮箱" v-model="visible_em" @ok="hideModal_em" okText="确认" cancelText="取消">
				<a-form :form="form" @submit="handleSubmit_em" class="common_alert">
					<p v-if="users.email">为了保护你的账号安全，变更前需要验证身份， 您的当前邮箱是{{users.email.replace(/(\w{3}(?=@\w+?.\S+))/,
						'***')}}</p>
					<div v-if="users.email">
						<a-form-item>
							<a-input
									v-decorator="['oldMail',{rules: [{ required: true, message: ' ' },{validator:checkEmails}]}]"
									placeholder="请输入完整的当前邮箱"
							/>
						</a-form-item>
					</div>

					<h4>请输入您要绑定的新邮箱</h4>
					<div>
						<a-form-item>
							<a-input
									v-decorator="['newMail',{rules: [{validator:this.handleEmailCheck}]}]"
									placeholder="请输入新的邮箱"
							/>
						</a-form-item>
					</div>
					<div>
						<a-form-item>
							<a-input
									style="width:52%;vertical-align: top;"
									v-decorator="['emailCode',{rules: [{ required: true, message: '请输入验证码!' }]}]"
									placeholder="请输入验证码"
							/>
							<a-button
									class="ant-btn-code fr"
									style="width:102px;"
									@click="SmsMsgSendMail"
									:disabled="SmsDisbled"
							>{{smsCodeText}}{{smsCodeText=='获取验证码'?'':'S'}}
							</a-button>
							<!--   <a-input
							class="fr"
							style="width:40%;"
							type="button"
							value="获取验证码"
							placeholder="请输入完整的当前手机号码"
							/>-->
							<!--            <a-button class="ant-btn-code fr" style="width:102px;" @click="SmsMsgSend">{{smsCodeText}}{{smsCodeText=='获取验证码'?'':'S'}}</a-button> -->
						</a-form-item>
					</div>
				</a-form>
			</a-modal>
		</div>
	</div>
</template>
<script>
  import {mapState, mapMutations} from "vuex";
  import UpdateAvatar from "./UpdateAvatar";
  import {
    checkTel,
    regAll,
    checkQQ,
    checkEmails,
    setString,
    checkTelN
  } from "../../common/validate";

  export default {
    name: "Profile",
    components: {UpdateAvatar},
    data() {
      return {
        regAll: regAll,
        checkTel: checkTel,
        checkQQ: checkQQ,
        checkTelN: checkTelN,
        checkEmails: checkEmails,
        visible: false,
        visible_pw: false,
        visible_em: false,
        updateAvatarModelVisible: false,
        profileEditVisiable: false,
        users: {},
        usersDep: {},
        contentList: {
          tab1: "content1"
        },
        tabListNoTitle: [
          {
            key: "个人中心",
            tab: "个人中心"
          }
        ],
        key: "tab1",
        noTitleKey: "个人中心",
        smsCodeText: "获取验证码",
        smsInterval: null,
        SmsDisbled: false,
        SmsSendDisbled: false,
      };
    },
    computed: {
      ...mapState({
        multipage: state => state.setting.multipage,
        user: state => state.account.user
      }),
      avatar() {
        return `/avatar/${this.user.avatar}`;
      },
      sex() {
        switch (this.user.ssex) {
          case "0":
            return "男";
          case "1":
            return "女";
          case "2":
            return "保密";
          default:
            return this.user.ssex;
        }
      }
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },
    created() {

      this.getData();
    },
    methods: {
      ...mapMutations({
        setUser: "account/setUser"
      }),
      //修改手机通知信息
      onChangeSystem(checked) {
        this.$put(
          "user/profile",
          {
            smsSystem: checked,
            userId: this.users.userId,
            username: this.users.username
          },
          true
        ).then(
          res => {
            this.$message.success(res.data.message);
          },
          () => {
            this.spinning = false;
          }
        );
      },
      onChangeTodo(checked) {
        this.$put(
          "user/profile",
          {
            smsTodo: checked,
            userId: this.users.userId,
            username: this.users.username
          },
          true
        ).then(
          res => {
            this.$message.success(res.data.message);
          },
          () => {
            this.spinning = false;
          }
        );
      },
      onChangeEmail(checked){
        this.$put(
          "user/profile",
          {
            emailSendMark: checked,
            userId: this.users.userId,
            username: this.users.username
          },
          true
        ).then(
          res => {
            this.$message.success(res.data.message);
          },
          () => {
            this.spinning = false;
          }
        );
      },
      //获取用户信息
      getData() {
        this.spinning = true;
        this.$get("user/getUserDetailByUserId", {
          userId: this.user.userId
        }).then(
          res => {
            this.users = res.data.data;
            this.usersDep = Object.assign({}, res.data.data);
            if (this.users.deptName) {
              // this.users.deptName = this.users.deptName.replace(
              //   /^(.).+(.)$/,
              //   "$1***$2"
              // );
            }
            if (this.users.mobile) {
              this.users.mobile = this.users.mobile.replace(
                /(\d{3})\d{4}(\d{4})/,
                "$1****$2"
              );
            }
            if (this.users.email) {
              this.users.email = this.users.email.replace(
                /(\w{3}(?=@\w+?.\S+))/,
                "***"
              );
            }
          },
          () => {
            this.spinning = false;
          }
        );
      },
      showModal() {
        this.visible = true;
      },
      hideModal(e) {
        this.handleSubmit(e);
      },
      showModal_pw() {
        this.visible_pw = true;
      },
      hideModal_pw(e) {
        this.handleSubmit_pw(e);
        // this.visible_pw = false;
      },
      showModal_em() {
        this.visible_em = true;
      },
      hideModal_em(e) {
        this.handleSubmit_em(e);
      },
      //密码修改
      handleSubmit_pw() {
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            this.loading = true;
            let newPassword = this.form.getFieldValue("newPassword");
            let password = this.form.getFieldValue("password");
            // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
            this.$put(
              "user/password/change",
              {
                newPassword: newPassword,
                password: password,
                username: this.users.username
              },
              false
            )
              .then(r => {
                if (r.data.code) {
                  this.$message.success(r.data.message);
                  this.visible_pw = false;
                } else {
                  this.$message.error(r.data.message);
                }
              })
              .catch(e => {
                this.visible_pw = false;
              });
          }
        });
      },
      handlePhoneNumberCheck(rule, value, callback) {
        if (value) {
          if (!this.regAll.regTel.test(value)) {
            callback(new Error("请输入合法的手机号码"));
          } else {
            callback();
          }
        } else {
          callback("请输入手机号码");
        }
      },
      handlePhoneCheck(rule, value, callback) {
        let oldMobile = this.form.getFieldValue("oldMobile");
        if (value) {
          if (!this.regAll.regTel.test(value)) {
            callback(new Error("请输入合法的手机号码"));
          } else if (value && oldMobile && value.trim() == oldMobile.trim()) {
            callback(new Error("手机号码重复"));
          } else {
            callback();
          }
        } else {
          callback("请输入新的手机号码");
        }
      },
      handleEmailCheck(rule, value, callback) {
        let oldMobile = this.form.getFieldValue("oldMail");
        if (value) {
          if (value && !this.regAll.regEmail.test(value)) {
            callback(new Error("请输入合法的邮箱"));
          } else if (value && oldMobile && value.trim() == oldMobile.trim()) {
            callback(new Error("邮箱信息重复"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入邮箱"));
        }
      },
      handlePasswordCheck(rule, value, callback) {
        let newPassword = this.form.getFieldValue("newPassword");
        // if (value === undefined) {
        //   callback(new Error('请输入密码'))
        // }
        if (value && !this.regAll.regPassword.test(value)) {
          callback(new Error("请输入正确的密码格式"));
        }
        if (value && newPassword && value.trim() !== newPassword.trim()) {
          callback(new Error("两次密码不一致"));
        }
        callback();
      },
      handlePasswordChecks(rule, value, callback) {
        let note = this.form.getFieldValue("note");
        // if (value === undefined) {
        //   callback(new Error('请输入密码'))
        // }
        // if(value&&)
        if (value && !this.regAll.regPassword.test(value)) {
          callback(new Error("请输入正确的密码格式"));
        }
        if (value && note && value.trim() !== note.trim()) {
          callback(new Error("两次密码不一致"));
        }
        callback();
      },
      checkUser(rule, value, callback) {
        if (value != this.usersDep.mobile) {
          callback(new Error("请输入原手机号码"));
        } else {
          callback();
        }
      },
      //手机号修改
      handleSubmit() {
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            if (this.users.mobile) {
              let oldMobile = this.form.getFieldValue("oldMobile");
              let newMobile = this.form.getFieldValue("newMobile");
              let smsCode = this.form.getFieldValue("smsCode");
              // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
              this.$put(
                "user/updateMobile",
                {
                  oldMobile: oldMobile,
                  newMobile: newMobile,
                  smsCode: smsCode
                },
                false
              )
                .then(r => {
                  if (r.data.code == 0) {
                    this.$message.error(r.data.message);
                  } else {
                    this.$message.success(r.data.message);
                    this.getData();
                    this.visible = false;
                  }

                })
                .catch(e => {
                  this.$message.error(e.response.data.message);
                  // this.visible = false;
                });
            } else {
              let phoneNumber = this.form.getFieldValue("phoneNumber");
              let smsCode = this.form.getFieldValue("smsCode");
              // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
              this.$put(
                "user/bindingMobile",
                {
                  phoneNumber: phoneNumber,
                  smsCode: smsCode
                },
                false
              )
                .then(r => {
                  if (r.data.code == 0) {
                    this.$message.error(r.data.message);
                  } else {
                    this.$message.success(r.data.message);
                    this.getData();
                    this.visible = false;
                  }

                })
                .catch(e => {
                  this.$message.error(e.response.data.message);
                  // this.visible = false;
                });
            }

          }
        });
      },
      //手机号修改发送验证码
      SmsMsgSend() {
        let oldMobile = '';
        let newMobile = '';
        if (this.users.mobile) {
          oldMobile = this.form.getFieldValue("oldMobile");
          newMobile = this.form.getFieldValue("newMobile");
          if (!oldMobile) {
            this.$message.error("手机号与原手机号不一致");
            return;
          }
          if (!newMobile) {
            this.$message.error("请输入要绑定的新手机号码");
            return;
          }
        } else {
          newMobile = this.form.getFieldValue("phoneNumber");
          if (!newMobile) {
            this.$message.error("请输入要绑定的新手机号码");
            return;
          }
        }
        this.$post(
          "info/smsMsg/open/send",
          {
            type: "reset",
            mobile: newMobile
          },
          false
        )
          .then(r => {
            this.$message.success("验证码已发送！");
            this.SmsSendDisbled = true;
            if (this.smsCodeText == "获取验证码") {
              this.smsCodeText = 60;
              this.smsInterval = setInterval(() => {
                this.smsCodeText = this.smsCodeText - 1;
                if (this.smsCodeText == 0) {
                  this.smsCodeText = "获取验证码";
                  clearInterval(this.smsInterval);
                  this.smsInterval = "";
                  this.SmsSendDisbled = false;
                  this.SmsMsgSendFlag = true;
                }
              }, 1000);
            }
          })
          .catch(e => {
            this.$message.error(e.response.data.message);
          });
      },
      //邮箱修改
      handleSubmit_em() {
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            let oldMail = this.form.getFieldValue("oldMail");
            let newMail = this.form.getFieldValue("newMail");
            let emailCode = this.form.getFieldValue("emailCode");
            // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
            this.$put(
              "user/updateMail",
              {
                oldMail: oldMail,
                newMail: newMail,
                emailCode: emailCode
              },
              false
            )
              .then(r => {
                if (r.data.code) {
                  this.$message.success(r.data.message);
                  this.getData();
                  this.visible_em = false;
                } else {
                  this.$message.error(r.data.message);
                }
              })
              .catch(e => {
                // this.visible_em = false;
                this.$message.error(e.response.data.message);
              });
          }
        });
      },
      //邮箱修改发送验证码
      SmsMsgSendMail() {
        let oldMail = this.form.getFieldValue("oldMail");
        let newMail = this.form.getFieldValue("newMail");
        if (this.users.email && !oldMail) {
          this.$message.error("邮箱与原邮箱不一致");
          return;
        }
        if (!newMail) {
          this.$message.error("请输入要绑定的新邮箱");
          return;
        }
        this.$post(
          "info/emailMsg/open/sendCode",
          {
            email: newMail
          },
          false
        )
          .then(r => {
            this.$message.success("验证码已发送！");
            this.SmsDisbled = true;
            // setTimeout(() => {
            //   this.form.setFieldsValue({
            //     emailCode: r.data.data
            //   });
            // }, 0);
            if (this.smsCodeText == "获取验证码") {
              this.smsCodeText = 60;
              this.smsInterval = setInterval(() => {
                this.smsCodeText = this.smsCodeText - 1;
                if (this.smsCodeText == 0) {
                  this.smsCodeText = "获取验证码";
                  clearInterval(this.smsInterval);
                  this.smsInterval = "";
                  this.SmsDisbled = false;
                  this.SmsMsgSendFlag = true;
                }
              }, 1000);
            }
          })
          .catch(e => {
            this.$message.error(e.response.data.message);
          });
      },

      handleUpdateAvatarCancel() {
        this.updateAvatarModelVisible = false;
      },
      handleUpdateAvatarSuccess(avatar) {
        this.updateAvatarModelVisible = false;
        this.$message.success("更换头像成功");
        let user = this.user;
        user.avatar = avatar;
        this.setUser(user);
      },
      updateAvatar() {
        this.updateAvatarModelVisible = true;
        this.userId = this.user.userId;
      },
      updateProfile() {
        this.$refs.updateProfile.setFormValues(this.user);
        this.profileEditVisiable = true;
      },
      handleProfileEditClose() {
        this.profileEditVisiable = false;
      },
      handleProfileEditSuccess() {
        this.profileEditVisiable = false;
        this.$message.success("修改成功");
      }
    }
  };
</script>
<style lang="scss" scoped>
	.hone_page_margin {
		padding-top: 30px;
		width: 1200px;
		margin: 0 auto;
		/deep/ .ant-tabs-ink-bar {
			height: 4px;
		}
	}

	/deep/ .wei_main_info {
		width: 100%;
		background-color: #fff;
		.ant-tabs-nav {
			margin-left: 86px;
		}
		.wei_main_info_main {
			width: 960px;
			margin: 30px auto;
			.ant-btn-primary,
			.ant-btn-primary:focus {
				width: 120px;
				height: 30px;
				line-height: 30px;
				color: #9da4ad;
				background-color: #fff;
				border: 1px solid rgba(225, 226, 229, 1);
			}
			.ant-btn-primary:hover,
			.ant-btn-primary:active {
				color: #fff;
				background: rgba(66, 142, 247, 1);
				border: 1px solid #428ef7;
			}
			.essential_information {
				padding: 31px 30px 0 30px;
				border: 1px solid rgba(225, 226, 229, 1);
				h2 {
					font-size: 16px;
					font-family: PingFang SC;
					font-weight: bold;
					color: rgba(22, 34, 50, 1);
					line-height: 36px;
				}
				.items:nth-of-type(1) {
					margin-top: 29px;
					img {
						width: 80px;
						height: 80px;
						border-radius: 50%;
					}
				}
				.items:nth-of-type(2),
				.items:nth-of-type(3),
				.items:nth-of-type(4),
				.items:nth-of-type(5) {
					height: 90px;
					line-height: 90px;
					border-bottom: 1px solid rgba(225, 226, 229, 1);
					> span:nth-of-type(1) {
						width: 100px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(164, 164, 164, 1);
						line-height: 36px;
						float: left;
						height: 90px;
						line-height: 90px;
					}
					> span:nth-of-type(2) {
						// width: 74px;
						height: 12px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(22, 34, 50, 1);
						line-height: 36px;
						float: left;
						height: 90px;
						line-height: 90px;
					}
				}
				.items-text {
					width: 200px;
				}
				.items-tip-text {
					width: 380px;
					display: inline-block;
					line-height: 26px;
					padding: 18px 0;
					margin-bottom: 0;
				}
			}
			.safe,
			.notice {
				.items:nth-of-type(1) {
					height: 90px;
					margin-top: 0;
					line-height: 90px;
					border-bottom: 1px solid rgba(225, 226, 229, 1);
					> span:nth-of-type(1) {
						width: 100px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(164, 164, 164, 1);
						line-height: 36px;
						float: left;
						height: 90px;
						line-height: 90px;
					}
					> span:nth-of-type(2) {
						// width: 74px;
						height: 12px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(22, 34, 50, 1);
						line-height: 36px;
						float: left;
						height: 90px;
						line-height: 90px;
					}
				}
			}
			.essential_information {
				.items:nth-of-type(5) {
					border-bottom: none;
				}
			}
			.safe {
				border-top: none;
				.items:nth-of-type(3) {
					border-bottom: none;
				}
			}
			.notice {
				border-top: none;
				.items:nth-of-type(2) {
					border-bottom: none;
				}
			}

			.ant-switch-checked {
				background-color: #3e7fff;
			}
		}
	}

	.ant-input:hover {
		border-color: #40a9ff;
		// color: #40a9ff;
	}

	.ant-input:focus {
		border-color: #40a9ff;
		// color: #40a9ff;
	}

	.common_alert {
		p {
			padding: 0 76px;
			white-space: normal;
			overflow: visible;
			color: #333;
		}
		.ant-form-item {
			padding: 0 76px;
			margin-bottom: 18px;
		}
		h4 {
			margin: -10px 76px 10px 76px;
			color: #333;
		}
	}
</style>
